import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AttachmentModalData } from '../../../Attachment/attachment.modal.model';
import { CommentModalData } from '../../../Comments/comments.service';

export interface ICellRendererParamsForFactorTableListGridAction extends ICellRendererParams {
    canEdit: () => boolean;
    viewDetails: (params: ICellRendererParamsForFactorTableListGridAction) => void;
    delete: (params: ICellRendererParamsForFactorTableListGridAction) => void;
    copy: (params: ICellRendererParamsForFactorTableListGridAction) => void;
}

@Component({
    selector: 'factor-table-list-grid-action-cell',
    template:
        `<button type="button" class="ace-btn btn-primary has-icon grid-action-button" title="View Details" (click)="onViewDetailsClicked()">
              <i class="fa fa-pencil"></i>
            </button>
            @if (canEdit) {
              <button type="button" class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Delete" (click)="onDeleteClicked()">
                <i class="fa fa-trash"></i>
              </button>
            }
            <span class="icon-indicator">
              <i class="fa" [ngClass]="{'fa-commenting':factorTableGridItem && factorTableGridItem.hasComments, 'fa-fw': !(factorTableGridItem && factorTableGridItem.hasComments)}"></i>
            </span>
            <span class="icon-indicator">
              <i class="fa" [ngClass]="{'fa-files-o':factorTableGridItem && factorTableGridItem.hasAttachments, 'fa-fw': !(factorTableGridItem && factorTableGridItem.hasAttachments)}"></i>
            </span>
            @if (factorTableGridItem) {
                <entity-comments [(hasComments)]="factorTableGridItem.hasComments"
                  [pinnedComment]="factorTableGridItem && factorTableGridItem.pinnedComment"
                  buttonClass="ace-btn btn-primary has-icon grid-action-button"
                  [modalData]="commentModalData">
                </entity-comments>
                <entity-attachments [(hasAttachments)]="factorTableGridItem.hasAttachments"
                  buttonClass="ace-btn btn-primary has-icon grid-action-button"
                  [modalData]="attachmentModalData">
                </entity-attachments>
            }
            <button type="button" class="ace-btn btn-primary has-icon grid-action-button" title="Copy" (click)="onCopyClicked()">
              <i class="fa-solid fa-clipboard"></i>
            </button>`,
    standalone: false
})
export class FactorTableListGridActionCellRendererComponent implements ICellRendererAngularComp {
    private _params: ICellRendererParamsForFactorTableListGridAction;
    factorTableGridItem: Compliance.FactorTableListItemModel;
    attachmentModalData: AttachmentModalData;
    commentModalData: CommentModalData;
    canEdit: boolean = false;

    agInit(params: ICellRendererParamsForFactorTableListGridAction): void {
        this._params = params;
        this.canEdit = params.canEdit();
        this.factorTableGridItem = params.data as Compliance.FactorTableListItemModel;
        if (!this.factorTableGridItem) {
            return;
        }
        this.attachmentModalData = {
            entityType: 'FactorTable', //todo: make this a constant generated typescript value
            entityName: this.factorTableGridItem.name,
            year: this.factorTableGridItem.taxYear,
            disableYears: false,
            singleYear: false,
            entityData: {
                typeId: Core.EntityTypes.FactorTable,
                id: this.factorTableGridItem.factorTableId,
                name: this.factorTableGridItem.name
            },
            readOnly: !this.canEdit
        } as AttachmentModalData;

        this.commentModalData = {
            entityID: this.factorTableGridItem.factorTableId,
            entityTypeID: Core.EntityTypes.FactorTable,
            parcelAcctNum: null,
            canEdit: this.canEdit,
            description: null,
            parcelID: null,
            year: this.factorTableGridItem.taxYear ? this.factorTableGridItem.taxYear.toString() : null
        } as CommentModalData;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this._params.viewDetails(this._params);
    }

    onDeleteClicked(): void {
        this._params.delete(this._params);
    }

    onCopyClicked() {
        this._params.copy(this._params);
    }
}
